export default {
  name: "participants",
  components: {},
  props: ["participants"],
  data() {
    return {
      showDialog: true
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
